module.exports = __webpack_public_path__ + "media/theme/icon__mobage-7b03bde1.svg";